/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { V1CoachPayout } from './V1CoachPayout'
import {
    V1CoachPayoutFromJSON,
    V1CoachPayoutFromJSONTyped,
    V1CoachPayoutToJSON,
    V1CoachPayoutToJSONTyped
} from './V1CoachPayout'

/**
 *
 * @export
 * @interface V1CoachPayouts
 */
export interface V1CoachPayouts {
    /**
     *
     */
    items: Array<V1CoachPayout>
}

/**
 * Check if a given object implements the V1CoachPayouts interface.
 */
export function instanceOfV1CoachPayouts(
    value: object
): value is V1CoachPayouts {
    if (!('items' in value) || value['items'] === undefined) return false
    return true
}

export function V1CoachPayoutsFromJSON(json: any): V1CoachPayouts {
    return V1CoachPayoutsFromJSONTyped(json, false)
}

export function V1CoachPayoutsFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachPayouts {
    if (json == null) {
        return json
    }
    return {
        items: (json['items'] as Array<any>).map(V1CoachPayoutFromJSON)
    }
}

export function V1CoachPayoutsToJSON(json: any): V1CoachPayouts {
    return V1CoachPayoutsToJSONTyped(json, false)
}

export function V1CoachPayoutsToJSONTyped(
    value?: V1CoachPayouts | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        items: (value['items'] as Array<any>).map(V1CoachPayoutToJSON)
    }
}
